// extracted by mini-css-extract-plugin
export default {"DetailsList":"DetailsList_DetailsList__hs854"};